import {
  SearchApiModel,
  useAxios,
  useDeleteNulls,
} from "@sttedra_ui/framework";

import UsersGroupsApiResponseModel from "./users-groups.api-response-model.js";
import UsersGroupsApiRequestModel from "./users-groups.api-request-model.js";

import { store } from "@/pages/_root/main.js";

// #region Globals
const { base } = useAxios();
const timeout = 5000;
// #endregion

// #region Public functions
async function appUserGroupList(searchParams = {}) {
  try {
    store.commit("setLoadingUserGroups", true);

    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = `/AppUserGroup/list`;

    const { data: response } = await base.post(url, searchModel, {
      timeout: 20000,
    });

    const { data: originalData, pageSize, pageIndex, totalResults } = response;

    const data = originalData.map((u) => new UsersGroupsApiResponseModel(u));

    store.commit("setLoadingUserGroups", false);

    return {
      data,
      pageSize,
      pageIndex,
      totalResults,
    };
  } catch (err) {
    store.commit("setLoadingUserGroups", false);
    localStorage.setItem("errorToastMessage", "Error al buscar los registros");

    return err;
  }
}

async function appUserGroupListAll(params) {
  try {
    const url = `/AppUserGroup/listAll`;

    const response = await base.post(url, params, {
      timeout,
    });

    const data = response.data;

    return data;
  } catch (err) {
    localStorage.setItem("errorToastMessage", "Error al buscar los registros");

    return err;
  }
}

// Create a user_group
async function appUserGroupCreate(params = {}) {
  try {
    // Create a new instance of the request model
    const UsersGroupsModel = new UsersGroupsApiRequestModel(params);

    // Delete nulls from the request model
    useDeleteNulls(UsersGroupsModel);

    const url = "/AppUserGroup/addUserGroup";

    const { data: response } = await base.post(url, UsersGroupsModel, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}

// Edit a user_group
async function appUserGroupUpdate(idGrupo, params = {}) {
  try {
    // Create a new instance of the request model
    const UsersGroupsModel = new UsersGroupsApiRequestModel(params);

    // Delete nulls from the request model
    useDeleteNulls(UsersGroupsModel);

    const url = `/AppUserGroup/${idGrupo}/updateUserGroup`;

    // Make the request
    const { data: response } = await base.put(url, UsersGroupsModel, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}

// Delete a user_group
async function appUserGroupDelete(idGrupo) {
  try {
    const url = `/AppUserGroup/${idGrupo}/deleteUserGroup`;

    // Make the request
    const { data: response } = await base.delete(url, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}

// Update the group that a user belongs to
async function appUserGroupAddUser(params = {}) {
  try {
    const url = `/AppUserGroup/user/AddUserToUserGroupRequest`;

    // Make the request
    const response = await base.post(url, params, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}

// Delete the group that a user belongs to
async function appUserGroupDeleteUser(params = {}) {
  try {
    const url = `/AppUserGroup/user/DeleteUserFromUserGroup`;

    // Make the request
    const response = await base.delete(
      url,
      {
        data: params,
      },
      {
        timeout,
      }
    );

    return response;
  } catch (err) {
    return err;
  }
}

// Get all the groups that a user belongs to
async function appUserGroupListByUser(params = {}) {
  try {
    const url = `/AppUserGroup/listByUser`;

    // Make the request
    const response = await base.post(
      url,
      {
        email: params.email,
        GLOBALSEARCH: params.GLOBALSEARCH,
      },
      {
        timeout,
      }
    );

    return response;
  } catch (err) {
    return err;
  }
}

// Get all the groups from Active Directory by name
async function appUserGroupListAD(params = {}) {
  try {
    const url = `/AppUserGroup/listAd`;

    // Make the request
    const response = await base.post(url, params, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}

// Get all the groups from UPRUC by name
async function appUserGroupListUpruc(params = {}) {
  try {
    const url = `/AppUserGroup/listUpruc`;

    // Make the request
    const response = await base.post(url, params, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}

function appUserGroupTypes() {
  let types = [
    {
      label: "Local",
      value: 0,
    },
    {
      label: "Directorio activo",
      value: 1,
    },
    {
      label: "UPRUC",
      value: 2,
    },
  ];

  return types;
}
// #endregion

// #region Private functions
// #endregion

export {
  appUserGroupList,
  appUserGroupListAll,
  appUserGroupCreate,
  appUserGroupUpdate,
  appUserGroupDelete,
  appUserGroupAddUser,
  appUserGroupDeleteUser,
  appUserGroupListByUser,
  appUserGroupListAD,
  appUserGroupListUpruc,
  appUserGroupTypes,
};
